import { styled } from '@mui/material/styles';
import { Dialog } from 'shared/mui/Dialogs';

export const StyledDialog = styled(Dialog)({
  '.MuiCardContent-root': {
    padding: 0,
    paddingBottom: '0 !important',
    ':&last-child': {
      paddingBottom: '0!important',
    },
  },
});
